import React, { useState, Component } from "react";
import "./../styles/iframe.css";
import ReactDOM from 'react-dom'

class ClinicalDocDisplay extends Component {
    constructor() {
        super();
        this.state = {
            iFrameHeight: '0px'
        }
    }

    render() {
        console.log('props url', this.props.src);

        return (
            <div style={this.props.style}>
                <iframe 
                className="pdf-iframe" 
                src= {this.props.src != "" ? (
                    `${this.props.src}#view=FitH&page=1`
                ): ("")}
                loading="lazy"
                // frameBorder = "0"
                // allowfullscreen
                // width="100%"
                // height= "800px"
                > 
                </iframe>
            </div>
        )
    }

}

export default ClinicalDocDisplay;